module.exports = __webpack_public_path__ + "static/media/contact-support.cd21c56c.svg";